import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ContractDetailView from './ContractDetailView';
import ContractListView from './contracts';
import AvalDetailView from '../client/AvalDetail';

const ContractView = () => (
  <Routes>
    <Route index element={<ContractListView />} />
    <Route path="contracts" element={<Navigate to="" replace />} />
    <Route path=":id/avals/:avalId/*" element={<AvalDetailView />} />
    <Route path=":id/avals/:avalId" element={<AvalDetailView />} />
    <Route path=":id/*" element={<ContractDetailView />} />
    <Route path=":id" element={<ContractDetailView />} />
  </Routes>
);

export default ContractView;
